import { Reveal } from "../Reveal";
import { COMPETENZE } from "../../data/content";

export const Competenze = () => (
  <section
    id="competenze"
    data-testid="competenze-section"
    className="relative border-t border-[#16181a]/12"
  >
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-14 md:py-32">
      <div className="mb-16 flex flex-col justify-between gap-6 md:mb-24 md:flex-row md:items-end">
        <Reveal>
          <div>
            <div className="flex items-baseline gap-4">
              <span className="font-display text-2xl italic text-[#c0442b]">02</span>
              <span className="overline">Competenze</span>
            </div>
            <h2 className="mt-6 max-w-2xl font-display text-4xl font-light leading-[1.05] tracking-tight text-[#16181a] md:text-6xl">
              Tre linguaggi,{" "}
              <span className="italic text-[#c0442b]">una regia</span>.
            </h2>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-sm font-body text-sm leading-relaxed text-[#6e6a64]">
            Le tre aree in cui lavoro non sono servizi separati: sono le forme in cui prende corpo
            la stessa direzione creativa.
          </p>
        </Reveal>
      </div>

      <div className="divide-y divide-[#16181a]/15 border-y border-[#16181a]/15">
        {COMPETENZE.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05}>
            <div
              data-testid={`competenza-${c.n}`}
              className="group grid grid-cols-12 items-start gap-6 py-10 transition-colors duration-500 md:gap-10 md:py-14"
            >
              <div className="col-span-2 md:col-span-1">
                <span className="font-display text-xl italic text-[#c0442b]">{c.n}</span>
              </div>
              <div className="col-span-10 md:col-span-4">
                <h3 className="font-display text-3xl font-light leading-tight text-[#16181a] md:text-5xl">
                  {c.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-7">
                <p className="max-w-2xl font-body text-base leading-relaxed text-[#2a2b2d] md:text-lg">
                  {c.desc}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
